<template>
  <button
    @click="$emit('click',$event)"
    type="button"
    class="inline-flex focus:outline-none"
  >
    <svg
      class="h-6 w-6 stroke-current"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  </button>
</template>

<script>
export default {};
</script>

<style>

</style>
